









import { defineComponent } from '@vue/composition-api';
import { DashboardWidgetHeaderColor } from '../types/enums/dashboard-widget-header-color';

export default defineComponent({
  props: {
    title: {
      type: String,
      required: true,
    },
    headerColor: {
      type: String,
      required: false,
      default: DashboardWidgetHeaderColor.Gray94,
    },
  },
});
